/*
  https://dash.cloudflare.com/682641d3732f5511ba839d47da31f50d/turnstile

  https://developers.cloudflare.com/turnstile/get-started/client-side-rendering/#configurations
*/

import { useEffect, useRef } from "preact/hooks";
import { doLog } from "@/lib/globals";
import { postEvent, postError } from "@/lib/api_controller";
import { TaaliaEvent } from "@/lib/event_types";
import { localStorageGet, STORAGE_KEYS } from "@/lib/storage";

const TURNSTILE_SITE_KEY = "0x4AAAAAABTDTpou_1lFQBSV"; // Taalia FW Phone Entry
const TURNSTILE_JS_URL =
  "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";

export default function TurnstileWidget({ onSuccess, onError }) {
  const containerId = "cf-turnstile-container";
  const didInit = useRef(false);
  const hasRendered = useRef(false);
  const widgetRef = useRef(null);
  // const lcid = localStorageGet(STORAGE_KEYS.lcidKey);
  const lcid = localStorageGet(STORAGE_KEYS.lcidKey);

  useEffect(() => {
    postEvent(TaaliaEvent.turnstileDisplayed);
  }, []);

  const handleError = async (msg, error) => {
    error = error ?? {};
    if (doLog()) console.error(msg, error);
    await postError(msg, error);
    await postEvent(TaaliaEvent.turnstileFailed, { msg, error });
    onError(msg, error);
  };

  const handleSuccess = (token) => {
    if (doLog()) console.log("Turnstile token received length:", token.length);
    postEvent(TaaliaEvent.turnstileSuccess, { tokenLength: token.length });
    onSuccess(token);
  };

  const renderWidget = () => {
    const container = document.getElementById(containerId);
    if (!container || !window.turnstile || hasRendered.current) return;
    try {
      if (widgetRef.current) window.turnstile.remove(widgetRef.current);
      container.innerHTML = "";
      widgetRef.current = window.turnstile.render(container, {
        sitekey: TURNSTILE_SITE_KEY,
        callback: handleSuccess,
        cData: lcid,
        "feedback-enabled": false,
        "before-interactive-callback": () => {
          console.log("Turnstile before interactive callback");
          postEvent(TaaliaEvent.turnstileEnteredInteractive);
        },
        "after-interactive-callback": () => {
          console.log("Turnstile after interactive callback");
          postEvent(TaaliaEvent.turnstileAfterInteractiveCallback);
        },
        "error-callback": (error) => handleError("TurnstileWidget: Widget error", error),
        "expired-callback": () => handleError("Expired", null),
        "unsupported-callback": () => handleError("Unsupported", null),
        "timeout-callback": () => {
          console.log("Turnstile timeout - attempting refresh");
          if (widgetRef.current) window.turnstile.reset(widgetRef.current);
        },
      });
      container.setAttribute("data-rendered", "true");
      hasRendered.current = true;
    } catch (error) {
      console.error("Turnstile render error details:", error);
      handleError("TurnstileWidget: Failed to render widget", error);
    }
  };

  const init = () => {
    if (didInit.current) return;
    didInit.current = true;

    if (typeof window === "undefined" || typeof document === "undefined") {
      handleError("TurnstileWidget: Browser environment not available");
      return;
    }

    const container = document.getElementById(containerId);
    if (!container) {
      handleError("TurnstileWidget: Container element not found");
      return;
    }

    if (!window.turnstile) {
      if (!document.querySelector(`script[src='${TURNSTILE_JS_URL}']`)) {
        const script = document.createElement("script");
        script.src = TURNSTILE_JS_URL;
        script.async = true;
        script.onload = () => setTimeout(renderWidget, 100);
        script.onerror = (e) => handleError("TurnstileWidget: Failed to load script", e);
        document.body.appendChild(script);
      }
    } else {
      renderWidget();
    }
  };

  useEffect(() => {
    if (doLog()) console.log("TurnstileWidget mounted");
    hasRendered.current = false;
    didInit.current = false;
    if (window.turnstile) window.turnstile.remove(widgetRef.current);
    init();
    return () => {
      const container = document.getElementById(containerId);
      if (container) {
        container.innerHTML = "";
        container.removeAttribute("data-rendered");
      }
      if (widgetRef.current && window.turnstile) {
        window.turnstile.remove(widgetRef.current);
        widgetRef.current = null;
      }
      hasRendered.current = false;
      didInit.current = false;
    };
  }, []);

  return (
    <div
      id={containerId}
      style={{
        minHeight: "65px",
        width: "300px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "0 auto",
      }}
    />
  );
}

// /*
//   https://dash.cloudflare.com/682641d3732f5511ba839d47da31f50d/turnstile
//   https://developers.cloudflare.com/turnstile/get-started/client-side-rendering/#configurations
// */

// import { useEffect, useRef } from "preact/hooks";
// import { doLog } from "@/lib/globals";
// import { postEvent } from "@/lib/taalia_api";
// import { TaaliaEvent } from "@/lib/event_types";

// // const TURNSTILE_SITE_KEY = "0x4AAAAAAA2PUqiNcCid9O7K"; // Taalia FW
// const TURNSTILE_SITE_KEY = "0x4AAAAAABTDTpou_1lFQBSV"; // Taalia FW Phone Entry
// const TURNSTILE_JS_URL = "https://challenges.cloudflare.com/turnstile/v0/api.js";

// export default function TurnstileWidget({ onSuccess, onError }) {
//   const containerId = "cf-turnstile-container";
//   const didInit = useRef(false);
//   const hasRendered = useRef(false);
//   const widgetRef = useRef(null);

//   useEffect(() => {
//     postEvent(TaaliaEvent.turnstileDisplayed);
//   }, []);

//   const handleError = (msg, error) => {
//     console.error(msg, error);
//     postEvent(TaaliaEvent.turnstileFailed, { msg, error });
//     onError(msg, error);
//   };

//   const handleSuccess = (token) => {
//     if (doLog()) console.log("Turnstile token received length:", token.length);
//     postEvent(TaaliaEvent.turnstileSuccess, { tokenLength: token.length });
//     onSuccess(token);
//   };

//   const renderWidget = () => {
//     const container = document.getElementById(containerId);
//     if (!container || !window.turnstile || hasRendered.current) return;

//     try {
//       // Remove any existing widget first
//       if (widgetRef.current) {
//         window.turnstile.remove(widgetRef.current);
//       }

//       // Clear the container
//       container.innerHTML = "";

//       // https://developers.cloudflare.com/turnstile/get-started/client-side-rendering/#configurations
//       widgetRef.current = window.turnstile.render(container, {
//         sitekey: TURNSTILE_SITE_KEY,
//         callback: handleSuccess,
//         "feedback-enabled": "false",
//         "before-interactive-callback": () => {
//           console.log("Turnstile before interactive callback");
//           postEvent(TaaliaEvent.turnstileEnteredInteractive);
//         },
//         "error-callback": (error) => handleError("TurnstileWidget: Widget error", error),
//         "expired-callback": () => handleError("Expired", null),
//         "unsupported-callback": () => handleError("Unsupported", null),
//         "timeout-callback": () => {
//           console.log("Turnstile timeout - attempting refresh");
//           if (widgetRef.current) {
//             window.turnstile.reset(widgetRef.current);
//           }
//         },
//       });
//       container.setAttribute("data-rendered", "true");
//       hasRendered.current = true;
//     } catch (error) {
//       console.error("Turnstile render error details:", error);
//       handleError("TurnstileWidget: Failed to render widget", error);
//     }
//   };

//   const init = () => {
//     if (didInit.current) return;
//     didInit.current = true;

//     if (typeof window === "undefined" || typeof document === "undefined") {
//       handleError("TurnstileWidget: Browser environment not available");
//       return;
//     }

//     const container = document.getElementById(containerId);
//     if (!container) {
//       handleError("TurnstileWidget: Container element not found");
//       return;
//     }

//     // Ensure the script is loaded before attempting to render
//     if (!window.turnstile) {
//       if (!document.querySelector(`script[src='${TURNSTILE_JS_URL}']`)) {
//         const script = document.createElement("script");
//         script.src = TURNSTILE_JS_URL;
//         script.async = true;
//         script.onload = () => {
//           // Add a small delay to ensure turnstile is fully initialized
//           setTimeout(renderWidget, 100);
//         };
//         script.onerror = (e) => handleError("TurnstileWidget: Failed to load script", e);
//         document.body.appendChild(script);
//       }
//     } else {
//       // If turnstile is already loaded, render immediately
//       renderWidget();
//     }
//   };

//   useEffect(() => {
//     if (doLog()) console.log("TurnstileWidget mounted");

//     // Reset state
//     hasRendered.current = false;
//     didInit.current = false;

//     // Clear any existing widgets
//     if (window.turnstile) {
//       window.turnstile.remove(widgetRef.current);
//     }

//     // Initialize
//     init();

//     return () => {
//       const container = document.getElementById(containerId);
//       if (container) {
//         container.innerHTML = "";
//         container.removeAttribute("data-rendered");
//       }
//       if (widgetRef.current && window.turnstile) {
//         window.turnstile.remove(widgetRef.current);
//         widgetRef.current = null;
//       }
//       hasRendered.current = false;
//       didInit.current = false;
//     };
//   }, []);

//   return (
//     <div
//       id={containerId}
//       style={{
//         minHeight: "65px",
//         width: "300px",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         margin: "0 auto",
//       }}
//     />
//   );
// }
